import {Injectable} from '@angular/core';
import {ICookieService} from './cookie-client.inteface.service';
import {SsrContext} from '../ssr-context.service';

@Injectable({
  providedIn: 'root',
})
export class CookieServerService implements ICookieService {
  private cookies: Record<string, string> = {};

  constructor(private ssrContext: SsrContext) {
    if (this.ssrContext.isServer()) {
      this.initializeCookies();
    }
  }

  private initializeCookies(): void {
    if (typeof globalThis !== 'undefined' && globalThis.__SSR_COOKIES__) {
      this.cookies = {...globalThis.__SSR_COOKIES__};
    } else {
      // Cookies par défaut ou vides en SSR
      this.cookies = {};
    }
  }

  getItem(name: string): string | null {
    if (!name) {
      return null;
    }

    if (this.ssrContext.isServer()) {
      return this.cookies[name] || null;
    }

    return null;
  }

  setItem(name: string, value: string, expiry?: Date | string, path?: string): boolean {
    if (!name) {
      return false;
    }

    if (!path) {
      path = '/';
    }

    if (this.ssrContext.isServer()) {
      // Stocker dans le cache local
      this.cookies[name] = value;

      if (typeof globalThis !== 'undefined') {
        if (!globalThis.__SSR_COOKIES__) {
          globalThis.__SSR_COOKIES__ = {};
        }
        globalThis.__SSR_COOKIES__[name] = value;
      }

      return true;
    }

    return false;
  }

  removeItem(name: string, path?: string): boolean {
    if (!name) {
      return false;
    }

    // En environnement serveur SSR Express
    if (this.ssrContext.isServer()) {
      // Supprimer du cache local
      delete this.cookies[name];

      // Supprimer de globalThis
      if (typeof globalThis !== 'undefined' && globalThis.__SSR_COOKIES__) {
        delete globalThis.__SSR_COOKIES__[name];
      }

      return true;
    }

    return false;
  }

  /**
   * Méthode utilitaire pour récupérer tous les cookies en SSR
   */
  getAllCookies(): Record<string, string> {
    if (this.ssrContext.isServer()) {
      return {...this.cookies};
    }
    return {};
  }

  /**
   * Méthode utilitaire pour définir plusieurs cookies en une fois
   */
  setCookies(cookiesObject: Record<string, string>): boolean {
    if (this.ssrContext.isServer()) {
      Object.entries(cookiesObject).forEach(([name, value]) => {
        this.setItem(name, value);
      });
      return true;
    }
    return false;
  }
}
